/** Lightbox — affiche une image en grand (lecture d'étiquette). Échap ou clic sur la croix / le fond ferme. */
import { useEffect } from 'react';
import { X } from 'lucide-react';

export function Lightbox({ src, alt = '', onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!src) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-ink/80 animate-fade-in p-6"
      onClick={onClose} data-testid="lightbox-overlay">
      <button onClick={onClose} aria-label="Fermer" data-testid="lightbox-close"
        className="absolute top-4 right-4 text-white/90 hover:text-white bg-black/30 rounded-full p-2">
        <X className="w-6 h-6" />
      </button>
      <img src={src} alt={alt} onClick={(e) => e.stopPropagation()} data-testid="lightbox-image"
        className="max-h-[92vh] max-w-[94vw] object-contain rounded shadow-2xl" />
    </div>
  );
}
